import { render, staticRenderFns } from "./SButtonLogout.vue?vue&type=template&id=55ab96c5"
import script from "./sButtonLogout.ts?vue&type=script&lang=ts&external"
export * from "./sButtonLogout.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ab96c5')) {
      api.createRecord('55ab96c5', component.options)
    } else {
      api.reload('55ab96c5', component.options)
    }
    module.hot.accept("./SButtonLogout.vue?vue&type=template&id=55ab96c5", function () {
      api.rerender('55ab96c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-button-logout/SButtonLogout.vue"
export default component.exports